const formatDocumentNumber = (prefix, number) => {
	const normalizedNumber = String(number ?? "").trim();
	return normalizedNumber ? `${prefix} N° ${normalizedNumber}` : `${prefix} S/N`;
};

export const formatPriceHistoryDocumentLabel = (row) => {
	if (row?.order_sale_id) {
		return formatDocumentNumber("FAC", row.order_sale_dealer_number);
	}

	if (row?.order_delivery_id) {
		if (row.order_delivery_is_without_document) {
			return formatDocumentNumber("SN", row.order_delivery_number);
		}
		return formatDocumentNumber("GD", row.order_delivery_number);
	}

	return "DOC S/N";
};
